/**
 * Runtime configuration loaded from /config.json at app startup.
 * Values are injected into window.__RUNTIME_CONFIG__ before React mounts.
 * In Docker containers, env.sh replaces placeholders at startup.
 */

export interface RuntimeConfig {
  maintenance: boolean;
  maintenanceStartDate: string;
  maintenanceEndDate: string;
  apiBaseUrl: string;
  wsUserName: string;
  wsPwd: string;
  msalClientId: string;
  msalAuthority: string;
  msalRedirectUri: string;
  msalPostLogoutRedirectUri: string;
}

declare global {
  interface Window {
    __RUNTIME_CONFIG__: RuntimeConfig;
  }
}

/**
 * Call once before React renders. Fetches /config.json and stores on window.
 */
export async function loadRuntimeConfig(): Promise<RuntimeConfig> {
  const res = await fetch(`${process.env.PUBLIC_URL}/config.json?ts=${Date.now()}`);
  const config: RuntimeConfig = await res.json();
  window.__RUNTIME_CONFIG__ = config;
  return config;
}

/**
 * Safe accessor — returns the config that was loaded at bootstrap.
 */
export function getRuntimeConfig(): RuntimeConfig {
  if (!window.__RUNTIME_CONFIG__) {
    throw new Error("Runtime config not loaded. Call loadRuntimeConfig() before app init.");
  }
  return window.__RUNTIME_CONFIG__;
}
